angular
  .module 'shared'
  .factory 'isInteger', ->
    (number) ->
      parseInt(number, 10) is parseFloat(number)
